// Mark Lookbook Order Placed
export const MARK_LOOKBOOK_ORDER_PLACED_REQUEST = 'MARK_LOOKBOOK_ORDER_PLACED_REQUEST';
export const MARK_LOOKBOOK_ORDER_PLACED_DONE = 'MARK_LOOKBOOK_ORDER_PLACED_DONE';
export const MARK_LOOKBOOK_ORDER_PLACED_FAILED = 'MARK_LOOKBOOK_ORDER_PLACED_FAILED';
export const MARK_LOOKBOOK_ORDER_PLACED_CLEAR_ERRORS = 'MARK_LOOKBOOK_ORDER_PLACED_CLEAR_ERRORS';
export const MARK_LOOKBOOK_ORDER_PLACED_RESET = 'MARK_LOOKBOOK_ORDER_PLACED_RESET';
